// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14s9W","right":"styles_right__QPGlm"};